module.exports = __webpack_public_path__ + "static/media/Head.14dc0fc4.png";